export const getUnitByIdEndpoint = 'AdministrativeUnit';
export const updateUnitEndpoint = 'AdministrativeUnit/Update';
